import { useEffect, useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Cabecalho from '../../components/Cabecalho';
import Rodape from '../../components/Rodape';
import { useCart } from '../../context/CartContext';
import './index.scss';

export default function PagamentoConcluido() {
    const [searchParams] = useSearchParams();
    const { clearCart } = useCart();

    const info = useMemo(() => ({
        orderNsu: searchParams.get('order_nsu') || '',
        captureMethod: searchParams.get('capture_method') || '',
        receiptUrl: searchParams.get('receipt_url') || ''
    }), [searchParams]);

    const metodo = info.captureMethod === 'credit_card' ? 'Cartao de Credito' : info.captureMethod === 'pix' ? 'PIX' : 'Pagamento Online';

    useEffect(() => {
        if (!info.orderNsu) return;
        clearCart();
    }, [clearCart, info.orderNsu]);

    return (
        <section className='container-pagamento-resultado sucesso'>
            <Cabecalho />
            <main>
                <div className='palco-status'>
                    <div className='fundo-status-svg' aria-hidden='true'>
                        <svg className='orb orb-1' viewBox='0 0 120 120'><circle cx='60' cy='60' r='60' /></svg>
                        <svg className='orb orb-2' viewBox='0 0 80 80'><circle cx='40' cy='40' r='40' /></svg>
                        <svg className='orb orb-3' viewBox='0 0 150 150'><circle cx='75' cy='75' r='75' /></svg>
                        <svg className='orb orb-4' viewBox='0 0 95 95'><circle cx='47.5' cy='47.5' r='47.5' /></svg>
                        <svg className='orb orb-5' viewBox='0 0 180 180'><circle cx='90' cy='90' r='90' /></svg>
                        <svg className='orb orb-6' viewBox='0 0 62 62'><circle cx='31' cy='31' r='31' /></svg>
                    </div>

                    <div className='icon'><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.50142 13.4762L4.60976 10.5845C4.45394 10.4287 4.24261 10.3411 4.02226 10.3411C3.8019 10.3411 3.59057 10.4287 3.43476 10.5845C3.27894 10.7403 3.19141 10.9516 3.19141 11.172C3.19141 11.2811 3.2129 11.3891 3.25465 11.4899C3.29641 11.5908 3.35761 11.6823 3.43476 11.7595L6.91809 15.2428C7.24309 15.5678 7.76809 15.5678 8.09309 15.2428L16.9098 6.42616C17.0656 6.27035 17.1531 6.05902 17.1531 5.83866C17.1531 5.61831 17.0656 5.40698 16.9098 5.25116C16.7539 5.09535 16.5426 5.00781 16.3223 5.00781C16.1019 5.00781 15.8906 5.09535 15.7348 5.25116L7.50142 13.4762Z" fill="#33BC02"/>
</svg>
</div>
                    <h1>Pagamento concluido com sucesso</h1>
                    <p>Seu pedido foi confirmado e ja esta em processamento.</p>
                    <div className='detalhes'>
                        <p className='numero-metodo'>
                            <span className='label'>Pedido:</span>
                            <strong>{info.orderNsu || 'Nao informado'}</strong>
                            <span className='separador'>|</span>
                            <span className='label'>Método:</span>
                            <strong>{metodo}</strong>
                        </p>
                    </div>
                    <div className='acoes'>
                        <Link to='/menu/perfil/meuspedidos' className='btn primario'>Ver meus pedidos</Link>
                        <Link to='/' className='btn secundario'>Voltar para a loja</Link>
                        {info.receiptUrl && (
                            <a href={info.receiptUrl} target='_blank' rel='noreferrer' className='btn terciario'>Ver comprovante</a>
                        )}
                    </div>
                </div>
            </main>
            <Rodape />
        </section>
    );
}
